interface MedicalDisclaimerProps {
  extra?: string
}

function MedicalDisclaimer({ extra }: MedicalDisclaimerProps) {
  return (
    <div className="bg-gray-50 border-l-4 border-teal-600 rounded-r-lg p-6">
      <p className="text-sm text-gray-600 leading-relaxed">
        <strong className="text-gray-900">Medical Disclaimer:</strong> The information provided on Vitamin Vital Portal is for informational and educational purposes only and is not intended as medical advice. Always consult with a qualified healthcare professional before starting any new supplement regimen, especially if you have existing health conditions or are taking medications. Individual results may vary.
        {extra ? ` ${extra}` : ""}
      </p>
    </div>
  )
}

export default MedicalDisclaimer
